import React from 'react'

/**
 * A non-interactive spacing component that expands to fill
 */
export const VideoSpacer = () => <div className='flex-1' />
